import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  children: React.ReactNode;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({ variant = 'primary', children, className = '', ...props }) => {
  const baseStyles = "inline-flex items-center justify-center px-6 py-3 rounded-full font-medium transition-all duration-300 text-sm tracking-wide";
  
  const variants = {
    primary: "bg-white text-black hover:bg-gray-200 hover:scale-105 shadow-[0_0_20px_rgba(255,255,255,0.3)]",
    secondary: "bg-white/10 backdrop-blur-md text-white border border-white/10 hover:bg-white/20 hover:scale-105",
    outline: "bg-transparent border border-white/30 text-white hover:border-white hover:bg-white/5",
    ghost: "text-gray-400 hover:text-white"
  };

  const { type = 'button', disabled = false, ...rest } = props as React.ButtonHTMLAttributes<HTMLButtonElement>;
  const disabledClass = disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : '';
  return (
    <button 
      type={type}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${className} ${disabledClass}`}
      {...rest}
    >
      {children}
    </button>
  );
};